(function () {
  function updateDynamicPrice() {
    const selected = document.querySelector(
      '.loop-widget-purchase-option-selected .loop-widget-purchase-option-price'
    );
    const target = document.querySelector('.rc_dynamic_price');
    if (selected && target) {
      target.textContent = selected.textContent.trim();
    }
  }

  function init() {
    const container = document.querySelector('.loop-widget-container');
    if (!container) return false;

    updateDynamicPrice();

    const observer = new MutationObserver(updateDynamicPrice);
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-checked'],
    });

    return true;
  }

  // Poll until the widget is in the DOM, then attach the observer
  if (!init()) {
    const poll = setInterval(function () {
      if (init()) clearInterval(poll);
    }, 200);
  }
})();